export const EMV_TAGS = {
  PAYLOAD_FORMAT_INDICATOR: "00",
  POINT_OF_INITIATION: "01",
  VISA: "02",
  MASTERCARD: "03",
  MASTERCARD_2: "04",
  MASTERCARD_3: "05",
  MERCHANT_ACCOUNT_INFO_START: 26,
  MERCHANT_ACCOUNT_INFO_END: 51,
  MERCHANT_CATEGORY_CODE: "52",
  TRANSACTION_CURRENCY: "53",
  TRANSACTION_AMOUNT: "54",
  TIP_INDICATOR: "55",
  TIP_FIXED: "56",
  TIP_PERCENTAGE: "57",
  COUNTRY_CODE: "58",
  MERCHANT_NAME: "59",
  MERCHANT_CITY: "60",
  POSTAL_CODE: "61",
  ADDITIONAL_DATA: "62",
  CRC: "63",
  MERCHANT_INFO_LANGUAGE: "64",
} as const;
